'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'links';

var Links = function (_Component) {
  (0, _inherits3.default)(Links, _Component);

  function Links() {
    (0, _classCallCheck3.default)(this, Links);
    return (0, _possibleConstructorReturn3.default)(this, (Links.__proto__ || (0, _getPrototypeOf2.default)(Links)).apply(this, arguments));
  }

  (0, _createClass3.default)(Links, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          links = _props.links,
          addClass = _props.addClass;


      if (links && links.length) {
        return _react2.default.createElement(
          'ul',
          { className: CLASS_NAME + ' ' + (addClass || '') },
          links.map(function (_ref, key) {
            var label = _ref.label,
                href = _ref.href,
                linkIcon = _ref.linkIcon,
                nestedLinks = _ref.links,
                onclick = _ref.onclick;
            return _react2.default.createElement(_Link2.default, {
              key: key,
              label: label,
              href: href,
              linkIcon: linkIcon,
              links: nestedLinks,
              onclick: onclick
            });
          })
        );
      }

      return null;
    }
  }]);
  return Links;
}(_react.Component);

exports.default = Links;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Links/Links.jsx
// module id = 429
// module chunks = 0